/* eslint-disable max-classes-per-file */

import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export enum AvailabilityDisplayType {
  PAT = 'PAT',
  RTS = 'RTS',
  DYNAMIC = 'DYNAMIC',
}
export class ProviderNextAvailability {
  personaProviderId: number;
  availabilityDisplayType: AvailabilityDisplayType;
  nextAvailableSlots: ProviderNextAvailableSlot[];
  constructor(response: IProviderNextAvailabilityResponse) {
    this.personaProviderId = response.persona_provider_id;
    this.availabilityDisplayType = response.availability_display_type;
    this.nextAvailableSlots = response.next_available_slots;
  }
}

export interface IProviderNextAvailabilityResponse {
  persona_provider_id: number;
  availability_display_type: AvailabilityDisplayType;
  next_available_slots: ProviderNextAvailableSlot[];
}

export interface PATVsRTSVariant {
  days: number;
  type: string;
  min_slots_required?: number;
}

export interface ProviderNextAvailabilityOptions {
  startDate: string;
  futureDate: string;
  personaProviderIds: number[];
  type: string;
  minSlotsRequired?: number;
  clientReferralId?: number;
  totalCalendarDays?: number;
}

export interface ProviderNextAvailableSlot {
  start: string;
  end: string;
}
export interface IProviderNextAvailabilityStore {
  getPatEnabledForProvider: (id) => Observable<ProviderAvailabilityInfo>;
  storeAllProvidersNextAvailability: (options: ProviderNextAvailabilityOptions) => void;
}

export type ProviderAvailabilityInfo = {
  patEnabled: boolean;
  availability?: ProviderNextAvailability;
};

export const PROVIDER_NEXT_AVAILABILITY_STORE = new InjectionToken<IProviderNextAvailabilityStore>('IProviderNextAvailabilityStore');
